import {authService, appConfigService} from '_app/services';
import {setBaseURL} from '_app/services/apiService.new';

if (window.ABM) {
	window.ABM.version = `${ABM_VERSION}-${BRANCH_NAME}`;
	window.ABM.mode = Mode;
} else {
	window.ABM = {
		version: `${ABM_VERSION}-${BRANCH_NAME}`,
		mode: Mode
	};
}

function bootstrap(settings = {}) {
	return authService.logonSSO(settings.authUrl)
		.then(appConfig => {
			appConfigService.set(appConfig);
			setBaseURL(appConfig.serverPath);
		});
}

export default {
	bootstrap
};